import styled from '@emotion/styled'
import { Button, spacing } from 'main/ui'

export const Container = styled.div`
  margin: ${spacing.minorScale(1)}px 0;
  display: flex;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${spacing.majorScale(1)}px;
`

export const StyledButton = styled(Button)`
  height: 35px;
  margin-left: auto;
  padding: 0;
  width: 80px;
`

export const DetailsContainer = styled.a`
  align-items: center;
  display: flex;
  flex-direction: row;
  text-decoration: none;
`
